import { greaterAreaCrudConfig } from '@/config/objects/greater-areas';
import { CrudFormView, PageContainer } from '@startupquickstart/frontend';
import { useNavigate, useParams } from 'react-router-dom';

export function GreaterAreaFormPage() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const itemId = id && id !== 'new' ? id : undefined;

  const breadcrumbs = [
    { label: 'Home', href: '/' },
    { label: 'Greater Areas', href: '/greater-areas' },
    { label: itemId ? 'Edit Greater Area' : 'New Greater Area', current: true },
  ];

  return (
    <PageContainer>
      <CrudFormView
        config={greaterAreaCrudConfig}
        itemId={itemId}
        breadcrumbs={breadcrumbs}
        onSuccess={() => navigate('/greater-areas')}
      />
    </PageContainer>
  );
}
